// printReceipt — ONE printable-receipt sheet, shared by the POS Receipts tab and the post-checkout
// confirmation card (Jose 2026-08-19). Opens a small window with a monospace receipt and triggers print.
// Returns false if the pop-up was blocked (caller decides how to surface that).
import { Receipt } from '../shared/receipts';

const money = (n: number) => `$${(n || 0).toFixed(2)}`;
const escapeHtml = (s: string) => (s || '').replace(/[&<>"']/g, c =>
  ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string));

export function printReceipt(r: Receipt): boolean {
  const w = window.open('', '_blank', 'width=380,height=640');
  if (!w) return false;
  const when = new Date(r.when).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
  const lineRows = r.lines.map(l =>
    `<tr><td>${l.qty > 1 ? l.qty + '× ' : ''}${escapeHtml(l.label)}</td><td class="r">${money(l.amount)}</td></tr>`).join('');
  const adj = (label: string, val: number, neg = false) =>
    val ? `<tr><td>${label}</td><td class="r">${neg ? '−' : ''}${money(val)}</td></tr>` : '';
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Receipt</title>
    <style>
      body{font-family:-apple-system,Menlo,monospace;max-width:320px;margin:16px auto;color:#111;font-size:13px}
      h1{font-size:16px;margin:0 0 2px} .muted{color:#666;font-size:12px}
      table{width:100%;border-collapse:collapse;margin-top:10px} td{padding:3px 0}
      .r{text-align:right} .sep td{border-top:1px dashed #999;padding-top:6px}
      .total td{font-weight:700;font-size:15px;border-top:2px solid #111;padding-top:6px}
      .foot{margin-top:14px;text-align:center;color:#666;font-size:11px}
    </style></head><body>
    <h1>SLIK</h1>
    <div class="muted">${when}</div>
    <div class="muted">${escapeHtml(r.clientName)}${r.barberName ? ' • ' + escapeHtml(r.barberName) : ''}</div>
    <table>
      ${lineRows}
      ${adj('Discount', r.discount, true)}
      ${adj('Emergency fee', r.emergencyFee)}
      ${adj('Tip', r.tip)}
      <tr class="total"><td>Total</td><td class="r">${money(r.total)}</td></tr>
      <tr><td class="muted">Paid</td><td class="r muted">${escapeHtml(r.paymentLabel)}</td></tr>
    </table>
    <div class="foot">Thank you!</div>
    <script>window.onload=function(){window.print();}</script>
    </body></html>`);
  w.document.close();
  return true;
}
